import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AddOfficeForm from "./addOfficeForm";
import {
  updateState,
  getSelectedCompany,
} from "../../../../Global/CustomFunctions";
import { Common } from "../../../../../utils";
import * as officeActions from "../officeActions";
class AddOffice extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      office: props.office,
      selectedCompany: getSelectedCompany(),
      officeErrors: props.officeErrors,
      loader: false,
    };
    this.updateState = this.updateState.bind(this);
    this.redirect = this.redirect.bind(this);
  }
  componentWillMount() {
    this.props.officeActions.clearOfcErrors();
  }
  updateState(event) {
    let result = updateState(event, this.state.office, this.state.officeErrors);
    this.setState({ office: result });
  }
  redirect() {
    let tempOffice = this.state.office;
    tempOffice.name = "";
    tempOffice.countryId = "";
    this.setState({ office: tempOffice });
    let selectedCompany = getSelectedCompany();
    let link = `/${selectedCompany.name}/offices`;
    this.props.history.push(link);
  }

  render() {
    return (
      <AddOfficeForm
        {...this.props}
      />
    );
  }
}
const mapStateToProps = ({ officeReducer, companyReducer }) => {
  const { office, offices, officeErrors } = officeReducer;
  const { selectedCompany, companyId } = companyReducer;
  return { office, officeErrors, offices, selectedCompany, companyId };
};
const mapDispatchToProps = (dispatch) => {
  return {
    officeActions: bindActionCreators(officeActions, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AddOffice);
